module.exports = __webpack_public_path__ + "img/svip.2cd11903.jpg";